import { useEffect, useMemo, useRef, useState } from "react";
import { Monitor, Smartphone } from "lucide-react";

const SCREENS = [
  ["Home", "/"],
  ["Question 1", "/question/workplace"],
  ["Scenario", "/scenario/desks-rooms"],
  ["Question 2", "/question/desks-rooms-mobility"],
  ["Result", "/recommendation?product=focus-620"],
  ["Compare", "/compare"],
];
const DEVICES = { phone: { w: 390, h: 844 }, desktop: { w: 1366, h: 768 } };

export function PreviewPane({ content }) {
  const [device, setDevice] = useState("phone");
  const [screen, setScreen] = useState(SCREENS[0][1]);
  const [scale, setScale] = useState(0.5);
  const frameRef = useRef(null);
  const holderRef = useRef(null);
  const size = DEVICES[device];

  const contentRef = useRef(content);
  contentRef.current = content;
  const post = useMemo(() => () => frameRef.current?.contentWindow?.postMessage({ type: "poly-fit-preview", content: contentRef.current }, window.location.origin), []);
  useEffect(() => { post(); }, [post, content]);
  useEffect(() => {
    const onReady = (event) => { if (event.origin === window.location.origin && event.data?.type === "poly-fit-preview-ready" && event.source === frameRef.current?.contentWindow) post(); };
    window.addEventListener("message", onReady);
    return () => window.removeEventListener("message", onReady);
  }, [post]);
  useEffect(() => {
    const fit = () => { const width = holderRef.current?.clientWidth || 400; setScale(Math.min(1, (width - 16) / size.w)); };
    fit();
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, [size.w]);

  return (
    <aside className="preview-pane" data-testid="cms-preview-pane">
      <div className="preview-toolbar">
        <div className="range-switch" data-testid="cms-preview-device-switch">
          <button type="button" className={device === "phone" ? "active" : ""} onClick={() => setDevice("phone")} data-testid="cms-preview-device-phone"><Smartphone size={14} /> Phone</button>
          <button type="button" className={device === "desktop" ? "active" : ""} onClick={() => setDevice("desktop")} data-testid="cms-preview-device-desktop"><Monitor size={14} /> Desktop</button>
        </div>
        <select value={screen} onChange={(e) => setScreen(e.target.value)} className="preview-screen-select" data-testid="cms-preview-screen-select">
          {SCREENS.map(([label, path]) => <option key={path} value={path}>{label}</option>)}
        </select>
      </div>
      <p className="preview-note" data-testid="cms-preview-note">Live preview of your unsaved edits · {size.w}×{size.h}</p>
      <div className={`preview-holder ${device}`} ref={holderRef} style={{ height: size.h * scale + 16 }}>
        <div className="preview-device" style={{ width: size.w, height: size.h, transform: `scale(${scale})` }}>
          <iframe ref={frameRef} title="Live preview" src={`${screen}${screen.includes("?") ? "&" : "?"}preview=1`} width={size.w} height={size.h} onLoad={post} data-testid="cms-preview-iframe" />
        </div>
      </div>
    </aside>
  );
}
